import { connect } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { KingdomCardComponent } from './KingdomCardComponent'
import { getFilteredCoupons } from 'shared/utils/ecommerce/utils'
import { kingdomCouponsSelector } from 'shared/store/kingdom/privileges'

const mapStateToProps = (state: RootState) => {
    const { authenticated } = state.userState
    const { pointInfos } = state.kingdomPointsPageState
    const kingdomCoupons = kingdomCouponsSelector(state)
    const {
        collectMode,
        restaurant,
        idsCouponsTemporaryBurned
    } = state.ecommerceOrderState
    const filteredCoupons = getFilteredCoupons(
        kingdomCoupons,
        restaurant,
        collectMode,
        idsCouponsTemporaryBurned
    )
    const nbCoupons = filteredCoupons.length
    return {
        authenticated,
        nbPoints: (pointInfos && pointInfos.points) || 0,
        nbCoupons
    }
}
const KingdomCard = connect(mapStateToProps)(KingdomCardComponent)

export { KingdomCard }
